import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ChangeDetectorRef } from "@angular/core";
import { AbstractControl, Form, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { DetalleDte } from "../../../models/Dte/DetalleDte";
import { DteEmitido } from "../../../models/Dte/DteEmitido";
import { TotalDte } from "../../../models/Dte/TotalDte";
import { NotaCredito } from "../../../models/NotaCredito";
import { TokenStorageService } from "../../../services/token-storage.service";
import { SessionUser } from "../../../shared/models/sessionUser";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { Receptor } from "../../../models/Receptor/Receptor";
import { environment } from "src/environments/environment";
import { PermissionService } from "src/app/services/permission.service";
import { Permission } from "src/app/shared/models/Permission";
import { NotaDebito } from "src/app/models/NotaDebito";
import { typeOfNullifyCN, typeOfNullifyCNForDN, typeOfNullifyCNForDteExport, typeOfNullifyDNForCN, typeOfNullifyDNForDteExport, typeOfNullifyDNInterests } from "src/app/models/Dte/TypeOfNullify.enum";
import * as moment from "moment";
import Swal from "sweetalert2";
import { FoliosService } from "src/app/services/folios.service";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';
type FormGroupAttach = [string, FormGroup];

@Component({
	selector: "app-anulador-dte",
	templateUrl: "./anulador-dte.component.html",
	styleUrls: ["./anulador-dte.component.scss"],
})
export class AnuladorDteComponent implements OnInit {
	@ViewChild("anuladorSwal") private anuladorSwal: SwalComponent;
	@Input() public receivedDte: DteEmitido;
	@Input() public notaCredito: boolean;
	@Input() public dteReferences: DteEmitido[];
	@Input() public DebitoMode: boolean = false;
	@Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output() private newCreditNoteRequest: EventEmitter<any> = new EventEmitter<any>();
	@Output() private newDebitNoteRequest: EventEmitter<any> = new EventEmitter<any>();
	@Output() private typeOfNullfySelected: EventEmitter<any> = new EventEmitter<any>();
	public dteNullifyForm: FormGroup;
	public dteDefaultNullForm: FormGroup;
	public dteAmountNullForm: FormGroup;
	public dteTextNullForm: FormGroup;
	public dteInterestsForm: FormGroup;
	public totalFoliosDisp: number = 0;
	private codigoSiiValidado: number = 0;
	public globalDiscountOriginalValue = 0;			
	public todayString = moment();
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "DD/MM/YYYY",
	};
	public validDate: boolean = true;
	public dateEmision: any = { startDate: moment.tz("America/Santiago"), endDate: moment.tz("America/Santiago") };

	public showInterestForm = false;
	public showNullifyDebitForm = false;
	public typeOfNullify = typeOfNullifyCN;
	public typeOfNullifyDNForCN = typeOfNullifyDNForCN;
	public typeOfNullifyDNInterests = typeOfNullifyDNInterests;
	public typeOfNullifyCNForDN = typeOfNullifyCNForDN;
	public typeOfNullifyCNForDteExport = typeOfNullifyCNForDteExport;
	public typeOfNullifyDNForDteExport = typeOfNullifyDNForDteExport;

	public typeOfNullifyValues: any;
	public typeOfNullifySelected = 0;

	public typeOfNullifyDNForCNValues: any;
	public typeOfNullifyDNForCNSelected = 0;

	public typeOfNullifyDNInterestsValues: any;
	public typeOfNullifyDNInterestsSelected = 0;

	public correccionItem: string;
	public newValueInterests: number = 0;
	public newIvaInterests: number = 0;
	public newTotalInterests: number = 0;
	public motivos = ["Error de digitación", "Reclamo de Cliente", "Otros"];
	public interestsMotive = ["Intereses por mora", "Intereses por cambio de fecha", "Otros"];
	public motivosCorrigeTextos = ["Error de digitación", "Datos desactualizados", "Otros"];
	public configScroll: PerfectScrollbarConfigInterface = {};
	private dteReferenciasDescuentosCorrecciones: DteEmitido[] = [];
	public totalDescontadoCorrecciones: number = 0;
	public totalesNota: TotalDte = new TotalDte();
	public noteToSend = new NotaCredito();
	public debitNoteToSend = new NotaDebito();
	public receivedReceptor: Receptor = new Receptor();
	public editingReceptor: Receptor = new Receptor();
	editing = {};
	public rowsReceivedDte: DetalleDte[] = [];
	public rowsDetalles: any[] = [];
	public arrayPermissions: Permission[] = [this.permissions.getPermission("40-18-30-10"), this.permissions.getPermission("40-18-30-12"), this.permissions.getPermission("40-18-30-14")];
	public arrayCreditoPermission: Permission[] = [this.permissions.getPermission("40-18-30-10"), this.permissions.getPermission("40-18-30-12"), this.permissions.getPermission("40-18-30-14")];
	public arrayDebitoPermissions: Permission[] = [this.permissions.getPermission("40-18-31-10"), this.permissions.getPermission("40-18-31-12"), this.permissions.getPermission("40-18-31-14")];
	private isGrossValue: boolean = false;
	constructor(private formBuilder: FormBuilder,
		private ref: ChangeDetectorRef,
		private tokenContainer: TokenStorageService, public permissions: PermissionService, private foliosService: FoliosService, private sessionUserService: SessionUserService
	) { }

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.isGrossValue = this.checkIfDteIsGrossValue();
		this.arrayPermissions = this.DebitoMode ? this.arrayDebitoPermissions : this.arrayCreditoPermission;
		this.receivedReceptor = { ...this.receivedDte.receptorAsociado };
		this.editingReceptor = { ...this.receivedReceptor };
		this.createNullifyForm();
		this.rowsReceivedDte = [...this.receivedDte.detalleDte].sort((a, b) => Number(a.nroitem) - Number(b.nroitem));
		this.ref.detectChanges();
		this.checkDetailsValueByDteType();
		this.verifyFolios();
		if (this.receivedDte.notaDebitoHabilitada && this.DebitoMode) {
			this.debitNoteToSend.usuarioId = (this.tokenContainer.getUser() as SessionUser).id;
			if (this.receivedDte.codigoTipoDte == 61) {
				this.showNullifyDebitForm = true;
				this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.debitNoteToSend);
				this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
				this.typeOfNullifyDNForCNValues = Object.values(this.typeOfNullifyDNForCN).filter((enumVal) => typeof enumVal == "number");
				this.dteNullifyForm.get("radioNullType").valueChanges.subscribe((currentRadioVal) => {
					switch (this.dteNullifyForm.get("radioNullType").value) {
						case 0:
							this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
							this.attachControls(this.dteNullifyForm, [["defaultForm", this.dteDefaultNullForm]]);
							this.resetArrayDetalles();
							break;
						default:
							break;
					}
				});
			} else if (this.receivedDte.codigoTipoDte == 112) {
				this.showNullifyDebitForm = true;
				this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.debitNoteToSend);
				this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
				this.typeOfNullifyDNForCNValues = Object.values(this.typeOfNullifyDNForDteExport).filter((enumVal) => typeof enumVal == "number");
				this.dteNullifyForm.get("radioNullType").valueChanges.subscribe((currentRadioVal) => {
					switch (this.dteNullifyForm.get("radioNullType").value) {
						case 0:
							this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
							this.attachControls(this.dteNullifyForm, [["defaultForm", this.dteDefaultNullForm]]);
							this.resetArrayDetalles();
							break;
						default:
							break;
					}
				});
			} else if (this.receivedDte.codigoTipoDte == 33 || this.receivedDte.codigoTipoDte == 34 || this.receivedDte.codigoTipoDte == 39 || this.receivedDte.codigoTipoDte == 41) {
				this.showInterestForm = true;
				this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.debitNoteToSend);
				this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "defaultForm"]);
				this.typeOfNullifyDNInterestsValues = Object.values(this.typeOfNullifyDNInterests).filter((enumVal) => typeof enumVal == "number");
				this.dteNullifyForm.get("radioNullType").valueChanges.subscribe((currentRadioVal) => {
					switch (this.dteNullifyForm.get("radioNullType").value) {
						case 0:
							this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "defaultForm"]);
							this.attachControls(this.dteNullifyForm, [["interestsForm", this.dteInterestsForm]]);
							this.resetArrayDetalles();
							break;
						default:
							break;
					}
				});
			}
		}

		if (this.receivedDte.notaCreditoHabilitada && !this.DebitoMode) {
			this.noteToSend.usuarioId = (this.tokenContainer.getUser() as SessionUser).id;
			this.globalDiscountOriginalValue = this.receivedDte?.descuentoGlobal ?? 0;
  			this.setupGlobalDiscountBehavior();
			if (this.receivedDte.codigoTipoDte == 111) {
				this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.noteToSend);
				this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
				this.typeOfNullifyValues = Object.values(this.typeOfNullifyCNForDN).filter((enumVal) => typeof enumVal == "number");
				this.dteNullifyForm.get("radioNullType").valueChanges.subscribe((currentRadioVal) => {
					switch (this.dteNullifyForm.get("radioNullType").value) {
						case 0:
							this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
							this.attachControls(this.dteNullifyForm, [["defaultForm", this.dteDefaultNullForm]]);
							this.resetArrayDetalles();
							break;
					}
				});
			}
			else if (this.receivedDte.codigoTipoDte != 56 && this.receivedDte.codigoTipoDte != 110) {
				this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.noteToSend);
				this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
				this.typeOfNullifyValues = Object.values(this.typeOfNullify).filter((enumVal) => typeof enumVal == "number");
				/*if (this.receivedDte.codigoTipoDte == 39) {
					this.typeOfNullifyValues = [0];
				}*/
				this.dteNullifyForm.get("radioNullType").valueChanges.subscribe((currentRadioVal) => {
					switch (this.dteNullifyForm.get("radioNullType").value) {
						case 0:
							this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
							this.attachControls(this.dteNullifyForm, [["defaultForm", this.dteDefaultNullForm]]);
							this.resetArrayDetalles();
							break;
						case 1:
							this.detachControls(this.dteNullifyForm, ["defaultForm", "radioTextGroup", "interestsForm"]);
							this.attachControls(this.dteNullifyForm, [["amountCorrectionGroup", this.dteAmountNullForm]]);
							this.resetArrayDetalles();
							break;
						case 2:
							this.detachControls(this.dteNullifyForm, ["defaultForm", "amountCorrectionGroup", "interestsForm"]);
							this.attachControls(this.dteNullifyForm, [["radioTextGroup", this.dteTextNullForm]]);
							this.resetArrayDetalles();
							break;
						default:
							break;
					}
				});
			} else if (this.receivedDte.codigoTipoDte == 56) {
				this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.noteToSend);
				this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
				this.typeOfNullifyValues = Object.values(this.typeOfNullifyCNForDN).filter((enumVal) => typeof enumVal == "number");
				this.dteNullifyForm.get("radioNullType").valueChanges.subscribe((currentRadioVal) => {
					switch (this.dteNullifyForm.get("radioNullType").value) {
						case 0:
							this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
							this.attachControls(this.dteNullifyForm, [["defaultForm", this.dteDefaultNullForm]]);
							this.resetArrayDetalles();
							break;
					}
				});
			} else if (this.receivedDte.codigoTipoDte == 110) {
				this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.noteToSend);
				this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
				this.typeOfNullifyValues = Object.values(this.typeOfNullifyCNForDteExport).filter((enumVal) => typeof enumVal == "number");
				this.dteNullifyForm.get("radioNullType").valueChanges.subscribe((currentRadioVal) => {
					switch (this.dteNullifyForm.get("radioNullType").value) {
						case 0:
							this.detachControls(this.dteNullifyForm, ["amountCorrectionGroup", "radioTextGroup", "interestsForm"]);
							this.attachControls(this.dteNullifyForm, [["defaultForm", this.dteDefaultNullForm]]);
							this.resetArrayDetalles();
							break;
					}
				});
			}
		}

		this.totalDescontadoCorrecciones = this.getDteSumByProperty(this.dteReferences, 61, "total");

		//this.dateEmision.startDate =  moment().startOf("day");
		//this.dateEmision.endDate = moment().subtract(1, "days").startOf("day");
		this.ref.detectChanges();
	}
	public get mostrarRut(): string {
		if (this.receivedDte.codigoTipoDte === 46) {
			return this.receivedDte.proveedor.rutProveedor;
		}
		return this.receivedDte.rutReceptorDv;
	}
	public get hasGlobalDiscountOrSurcharge(): boolean {
		console.log("dte:", this.receivedDte);
		return this.receivedDte?.descuentoGlobal > 0;
	}
	createNullifyForm() {
		this.dteAmountNullForm = this.formBuilder.group({
			arrayDetalles: [[]],
			comentarioDetalles: [, [Validators.required]],
			applyGlobalDiscount: [false],       // checkbox: aplicar o no
  			globalDiscountValue: [0],    
		});
		this.dteTextNullForm = this.formBuilder.group({
			comentarioTextCorrection: ["", [Validators.required]],
			motivoCorrigeTexto: [, [Validators.required]],
			rutReceptor: [this.mostrarRut],
			razonSocialReceptor: [this.receivedDte.razonSocial],
			giroReceptor: [this.editingReceptor.giro], //giro a editar
			direccionFacturacion: [this.editingReceptor.dirFact], //direccion a editar
			comunaReceptor: [this.editingReceptor.comuna], //direccion a editar
			ciudadReceptor: [this.editingReceptor.ciudad], //direccion a editar
			itemsCorreccion: [this.correccionItem]
		});
		this.disableControls([this.dteTextNullForm.controls.rutReceptor, this.dteTextNullForm.controls.razonSocialReceptor]);
		this.dteDefaultNullForm = this.formBuilder.group({
			motivo: [, [Validators.required]],
			comentario: [, [Validators.required]],
		});
		this.dteInterestsForm = this.formBuilder.group({
			motiveInterests: [, [Validators.required]],
			commentInterests: [, [Validators.required]],
			valueInterests: [, [Validators.required, Validators.min(1)]],
			ivaInterests: [,],
			exemptInterests: [,],
			totalInterests: [,],
		});

		this.dteNullifyForm = this.formBuilder.group({
			radioNullType: [this.arrayPermissions[0].asignado ? 0 : this.arrayPermissions[1].asignado ? 1 : this.arrayPermissions[2].asignado ? 2 : null],
			defaultForm: this.dteDefaultNullForm,
			amountCorrectionGroup: this.dteAmountNullForm,
			radioTextGroup: this.dteTextNullForm,
			interestsForm: this.dteInterestsForm,
		});
		this.sendNullType();
	}
	detachControls(parentFormGroup: FormGroup, childrenFormGroupToDetach: string[]) {
		childrenFormGroupToDetach.forEach((fg) => {
			parentFormGroup.removeControl(fg);
		});
	}
	attachControls(parentFormGroup: FormGroup, childrenFormGroupToAttach: FormGroupAttach[]) {
		childrenFormGroupToAttach.forEach((st) => {
			parentFormGroup.addControl(st[0], st[1]);
		});
	}
	disableControls(controls: AbstractControl[]) {
		//disable elements in form
		controls.forEach((control) => {
			control.disable();
		});
	}
	sendCloseRequest() {
		this.sendCloseRequestEmitter.emit();
	}
	updateValue(event, cell, rowIndex, row?) {
		const isDirectValue = row !== undefined;
		
		if (cell === "esExento") {
			const newValue = isDirectValue ? event : event.target.checked;
			this.rowsDetalles[rowIndex][cell] = newValue;
		} else if (cell === "cantidad" || cell === "precioUnitario") {
			const valueToUpdate = isDirectValue ? event : event.target.value;
			
			if (valueToUpdate < 0) {
				this.anuladorSwal.icon = "error";
				this.anuladorSwal.title = "Error en valor";
				this.anuladorSwal.text = "Ingresar solamente valores positivos";
				this.anuladorSwal.fire();
				if (isDirectValue) {
					setTimeout(() => {
						this.rowsDetalles = [...this.rowsDetalles];
						this.ref.detectChanges();
					}, 0);
				}
				return;
			} else {
				let roundedValue = Math.round(valueToUpdate * 1e6) / 1e6;
				this.rowsDetalles[rowIndex][cell] = roundedValue;
			}
		}

		this.rowsDetalles = [...this.rowsDetalles];
		this.updateRelatedValue(rowIndex, cell, "subtotal");
	}

	updateRelatedValue(currentRow: number, currentCell: string, cellToUpdate: string) {
		if (currentCell == "cantidad" || currentCell == "precioUnitario" || currentCell == "esExento") {
			//update last element
			let currentPrecio = this.rowsDetalles[currentRow]["precioUnitario"];
			let currentCantidad = this.rowsDetalles[currentRow]["cantidad"];
			if (currentPrecio < 0 || currentCantidad < 0) {
				this.anuladorSwal.icon = "error";
				this.anuladorSwal.title = "Error en valor";
				this.anuladorSwal.text = "Ingresar solamente valores positivos";
				this.anuladorSwal.fire();
				return;
			}
			this.rowsDetalles[currentRow][cellToUpdate] = Math.round(parseFloat(currentPrecio) * parseFloat(currentCantidad));
			this.rowsDetalles[currentRow]["total"] = Math.round(parseFloat(currentPrecio) * parseFloat(currentCantidad));
			this.rowsDetalles[currentRow]["precioUnitario"] = Number(parseFloat(currentPrecio));
			this.rowsDetalles[currentRow]["cantidad"] = Number(parseFloat(currentCantidad));
			this.rowsDetalles = [...this.rowsDetalles];
			this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.noteToSend);
		}
	}

	onSubmit() {
		if (this.dteNullifyForm.invalid) {
			return;
		}
		if (this.dteNullifyForm.valid) {
			this.noteToSend.dteReferencia = this.receivedDte;
			this.noteToSend.dteReferenciaId = this.receivedDte.dteId;
			this.noteToSend.fechaNota = moment.tz(this.dateEmision.startDate, "DD/MM/YYYY", "America/Santiago").toISOString();

			this.debitNoteToSend.dteReferencia = this.receivedDte;
			this.debitNoteToSend.dteReferenciaId = this.receivedDte.dteId;
			this.debitNoteToSend.fechaNota = moment.tz(this.dateEmision.startDate, "DD/MM/YYYY", "America/Santiago").toISOString();
			//check if form contains new dteDetails by current radioNullType
			if (this.dteNullifyForm.get("amountCorrectionGroup")) {
				const amountGroup = this.dteNullifyForm.get("amountCorrectionGroup") as FormGroup;
				this.dteNullifyForm.controls.amountCorrectionGroup.patchValue({
					arrayDetalles: this.rowsDetalles,
				});
				//check if details data is unchanged?

				//recalculate new totals
				this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.noteToSend);
				//set detalles to Request
				this.noteToSend.itemsNota = this.rowsDetalles;
				this.noteToSend.comentario = this.dteNullifyForm.controls.amountCorrectionGroup.get("comentarioDetalles").value;
				this.noteToSend.motivoString = "otros";
				this.noteToSend.applyGlobalDiscount = this.hasGlobalDiscountOrSurcharge === true;
				this.noteToSend.globalDiscountValue = this.hasGlobalDiscountOrSurcharge ? Number(amountGroup.get("globalDiscountValue")?.value) : 0;
				if (this.noteToSend.neto <= 5) {
					this.anuladorSwal.icon = "error";
					this.anuladorSwal.title = "Monto mínimo";
					this.anuladorSwal.text = "El monto del documento a generar debe ser mayor a 5";
					this.anuladorSwal.fire();
					return;
				}
				if (!this.amountValid()) {
					this.anuladorSwal.icon = "error";
					this.anuladorSwal.title = "Monto erroneo";
					this.anuladorSwal.text = "El monto del documento no puede ser mayor al monto total del documento en referencia";
					this.anuladorSwal.fire();
					return;
				} else if (!this.amountValidByDteHistory(this.noteToSend.total, this.totalDescontadoCorrecciones, this.receivedDte.total)) {
					this.anuladorSwal.icon = "error";
					this.anuladorSwal.title = "Monto erroneo";
					this.anuladorSwal.text = "El monto del documento actual no puede superar al monto total disponible para corregir el documento en referencia";
					this.anuladorSwal.fire();
					return;
				}
			} else if (this.dteNullifyForm.get("radioTextGroup")) {
				this.noteToSend.comentarioCorreccionTexto = this.dteNullifyForm.controls.radioTextGroup.get("comentarioTextCorrection").value;
				this.compareStringConcatenateRequest(this.dteNullifyForm.controls.radioTextGroup.get("giroReceptor"), this.noteToSend, this.receivedReceptor.giro, "Giro");
				this.compareStringConcatenateRequest(this.dteNullifyForm.controls.radioTextGroup.get("direccionFacturacion"), this.noteToSend, this.receivedReceptor.dirFact, "Dirección Facturacion");
				this.compareStringConcatenateRequest(this.dteNullifyForm.controls.radioTextGroup.get("comunaReceptor"), this.noteToSend, this.receivedReceptor.comuna, "Comuna");
				this.compareStringConcatenateRequest(this.dteNullifyForm.controls.radioTextGroup.get("ciudadReceptor"), this.noteToSend, this.receivedReceptor.ciudad, "Ciudad"); //para concatenar la soliciutd de anulación por correccion texto

				if (this.dteNullifyForm.controls.radioTextGroup.get("itemsCorreccion").value != "" && this.dteNullifyForm.controls.radioTextGroup.get("itemsCorreccion").value != null) {
					this.noteToSend.itemsNota.push({
						descripcion: this.dteNullifyForm.controls.radioTextGroup.get("itemsCorreccion").value
					});
				}

				this.noteToSend.motivoString = this.dteNullifyForm.controls.radioTextGroup.get("motivoCorrigeTexto").value;
				if (this.noteToSend.itemsNota.length == 0) {
					this.anuladorSwal.icon = "error";
					this.anuladorSwal.title = "Error en detalle";
					this.anuladorSwal.text = "Debe hacer al menos un cambio en algunos de los campos disponibles";
					this.anuladorSwal.fire();
					return;
				}
			} else if (this.dteNullifyForm.get("interestsForm")) {
				this.debitNoteToSend.comentario = this.dteNullifyForm.controls.interestsForm.get("commentInterests").value;
				this.debitNoteToSend.motivoString = this.dteNullifyForm.controls.interestsForm.get("motiveInterests").value;
				this.debitNoteToSend.neto = this.dteNullifyForm.controls.interestsForm.get("valueInterests").value;
				this.debitNoteToSend.iva = this.dteNullifyForm.controls.interestsForm.get("ivaInterests").value;
				this.debitNoteToSend.exento = this.dteNullifyForm.controls.interestsForm.get("valueInterests").value;
				if (this.debitNoteToSend.iva > 0) this.debitNoteToSend.exento = 0;
				this.debitNoteToSend.total = this.dteNullifyForm.controls.interestsForm.get("totalInterests").value;
			} else if (this.dteNullifyForm.get("defaultForm")) {
				this.noteToSend.comentario = this.dteNullifyForm.controls.defaultForm.get("comentario").value;
				this.noteToSend.motivoString = this.dteNullifyForm.controls.defaultForm.get("motivo").value;
				this.noteToSend.itemsNota = this.rowsDetalles;
				this.debitNoteToSend.comentario = this.dteNullifyForm.controls.defaultForm.get("comentario").value;
				this.debitNoteToSend.motivoString = this.dteNullifyForm.controls.defaultForm.get("motivo").value;
				this.debitNoteToSend.itemsNota = this.rowsDetalles;
			}
			this.typeOfNullifySelected = this.dteNullifyForm.get("radioNullType").value;
			this.typeOfNullifyDNForCNSelected = this.dteNullifyForm.get("radioNullType").value;
			this.typeOfNullifyDNInterestsSelected = this.dteNullifyForm.get("radioNullType").value;
			this.noteToSend.tipoNota = this.dteNullifyForm.get("radioNullType").value;
			this.debitNoteToSend.tipoNota = this.dteNullifyForm.get("radioNullType").value;
			if(this.totalFoliosDisp <= 0) {
				this.anuladorSwal.icon = "error";
				this.anuladorSwal.title = "Folios insuficientes";
				const tipoFolio = this.getTipoFolioDescripcion(this.codigoSiiValidado);
				this.anuladorSwal.text = `No hay suficientes folios disponibles para ${tipoFolio}. Actualmente, solo dispones de ${this.totalFoliosDisp} folios.`;
				this.anuladorSwal.fire();
				return;
			}
			if (this.receivedDte.notaDebitoHabilitada) this.newDebitNoteRequest.emit(this.debitNoteToSend);
			if (this.receivedDte.notaCreditoHabilitada) this.newCreditNoteRequest.emit(this.noteToSend);
		}
	}

	f() {
		return this.dteNullifyForm.controls;
	}

	calculateNewTotalsOfDocument(dteDetails: DetalleDte[], notaTotal: TotalDte, notaToRecalc?: NotaCredito) {
		let groupExentoDetalles = [];
		groupExentoDetalles = dteDetails.filter((detail) => detail.esExento == true || detail.esExento == undefined);
		let groupAfectoDetalles = [];
		groupAfectoDetalles = dteDetails.filter((detail) => detail.esExento == false);
		let totalExento: number = 0;
		let netoAfecto: number = 0;

		if (groupExentoDetalles) {
			groupExentoDetalles.forEach((detail) => {
				totalExento += Math.round(Number(parseFloat(detail.cantidad.toString()) * parseFloat(detail.precioUnitario.toString())));
				notaTotal.exento = totalExento;
			});
		}
		if (groupAfectoDetalles) {
			groupAfectoDetalles.forEach((detail) => {
				netoAfecto += Number(parseFloat(detail.cantidad.toString()) * parseFloat(detail.precioUnitario.toString()));
			});
			notaTotal.afecto = netoAfecto;
			notaTotal.neto = netoAfecto;
		}
		let discountToApply = 0;
		const amountGroup = this.dteNullifyForm?.get("amountCorrectionGroup") as FormGroup;

		if (amountGroup && this.hasGlobalDiscountOrSurcharge) {
			const apply = amountGroup.get("applyGlobalDiscount")?.value === true;
			const value = Number(amountGroup.get("globalDiscountValue")?.value ?? 0);
			discountToApply = apply ? Number(this.globalDiscountOriginalValue ?? 0) : value;
		}
		const netoAfectoConDescto = Math.max(0, Math.round(netoAfecto) - Math.round(discountToApply));

		notaTotal.afecto = netoAfectoConDescto;
		notaTotal.neto = netoAfectoConDescto;
		notaTotal.subTotal = Number(totalExento + netoAfectoConDescto);
		let Iva: number = Math.round(Math.round(netoAfectoConDescto) * environment.taxPercentage);
		notaTotal.iva = Iva;
		let totalAfecto: number = Number(netoAfectoConDescto + Iva);
		notaToRecalc.neto = Number(totalExento + netoAfectoConDescto);
		notaToRecalc.iva = Iva;
		notaToRecalc.total = Number(totalExento + totalAfecto);
		notaTotal.total = notaToRecalc.total;
	}
	amountValid(): boolean {
		//valida que el total de la nota no sea mayor que el total del documento en referencia recibido (receivedDte)
		return this.noteToSend.total <= this.receivedDte.total && this.noteToSend.total > 0;
	}
	deleteDetailElement(row) {
		let elementToDelete = this.rowsDetalles.find((detailElement) => detailElement.detalleDteId == row.detalleDteId);
		if (elementToDelete) {
			let itemIndexToDelete = this.rowsDetalles.indexOf(elementToDelete);
			this.rowsDetalles.splice(itemIndexToDelete, 1);
			this.rowsDetalles = [...this.rowsDetalles];
			this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.noteToSend);
		}
	}
	passElementToNote(row) {
		let localRow = { ...row };
		let resultFindRow = this.rowsDetalles.find((detailElement) => detailElement.detalleDteId == row.detalleDteId);
		if (!resultFindRow) {
			this.rowsDetalles.push(localRow);
			this.rowsDetalles = [...this.rowsDetalles];
			this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.noteToSend);
		}
	}

	compareStringConcatenateRequest(controlToCheck: AbstractControl, requestObject: NotaCredito, atributoComparado: string, nombreCampo: string) {
		let detalleTexto: DetalleDte = new DetalleDte();
		if (!requestObject.itemsNota) {
			requestObject.itemsNota = [];
		}
		if (atributoComparado != controlToCheck.value) {
			detalleTexto.descripcion = 'En el campo "' + nombreCampo + '" donde dice "' + atributoComparado + '" debe decir "' + controlToCheck.value + '"';
			var exist = requestObject.itemsNota.filter((x) => x.descripcion == detalleTexto.descripcion);
			if (exist.length == 0) requestObject.itemsNota.push(detalleTexto);
		}
	}

	getDteSumByProperty(arrayDte: DteEmitido[], codigoTipoDte: number, propertyToSum: string) {
		let sum: number = 0;
		if (arrayDte) {
			arrayDte.forEach((dte) => {
				if (dte.codigoTipoDte == codigoTipoDte && !dte.anulado) {
					sum += dte[propertyToSum];
				}
			});
		}
		return sum;
	}

	amountValidByDteHistory(currentAmount, historyAmount, originalAmount): boolean {
		//valida que el monto de la nota actual no sobrepase el total del dte original, considerando los montos de notas previas vigentes(no nulos)
		return currentAmount <= originalAmount - historyAmount;
	}
	resetArrayDetalles() {
		this.rowsDetalles = [];
	}

	checkDetailsValueByDteType() {
		if (this.receivedDte.codigoTipoDte == 39 || this.receivedDte.codigoTipoDte == 41 || this.receivedDte.codigoTipoDte == 33) {
			this.rowsReceivedDte.forEach((detail) => {
				detail.precioUnitario = this.isGrossValue ? Math.round(detail.precioUnitario / (1 + environment.taxPercentage)) : +detail.precioUnitario.toFixed(2);
				let detailWithDiscount = detail.descuento ? detail.precioUnitario * detail.cantidad - detail.descuento : detail.precioUnitario * detail.cantidad;
				detail.subtotal = detail.recargo ? detail.precioUnitario * detail.cantidad + detail.recargo : detailWithDiscount;
				detail.total = detail.subtotal;
			});
		}
		if (this.receivedDte.notaCreditoHabilitada && !this.DebitoMode) {
			if (this.receivedDte.codigoTipoDte != 56 && this.receivedDte.codigoTipoDte != 110) this.typeOfNullifyValues = Object.values(this.typeOfNullify).filter((enumVal) => typeof enumVal == "number");
			if (this.receivedDte.codigoTipoDte == 56) this.typeOfNullifyValues = Object.values(this.typeOfNullifyCNForDN).filter((enumVal) => typeof enumVal == "number");
			if (this.receivedDte.codigoTipoDte == 43) this.typeOfNullifyValues = Object.values(this.typeOfNullifyCNForDteExport).filter((enumVal) => typeof enumVal == "number");
		}
		if (this.receivedDte.notaDebitoHabilitada && this.DebitoMode) {
			if (this.receivedDte.codigoTipoDte == 61) this.typeOfNullifyDNForCNValues = Object.values(this.typeOfNullifyDNForCN).filter((enumVal) => typeof enumVal == "number");
			if (this.receivedDte.codigoTipoDte == 112) this.typeOfNullifyDNForCNValues = Object.values(this.typeOfNullifyDNForDteExport).filter((enumVal) => typeof enumVal == "number");
			if (this.receivedDte.codigoTipoDte == 33 || this.receivedDte.codigoTipoDte == 33 || this.receivedDte.codigoTipoDte == 39 || this.receivedDte.codigoTipoDte == 41) this.typeOfNullifyDNInterestsValues = Object.values(this.typeOfNullifyDNInterests).filter((enumVal) => typeof enumVal == "number");
		}
	}
	updateValueInterest(value: number) {
		this.newValueInterests = value;
		if (this.receivedDte.codigoTipoDte == 41 || this.receivedDte.codigoTipoDte == 34) {
			this.newTotalInterests = Number((this.newValueInterests).toFixed(2));
		} else {
			this.newIvaInterests = Number((this.newValueInterests * 0.19).toFixed(2));
			this.newTotalInterests = Number((Number(this.newIvaInterests) + Number(this.newValueInterests)).toFixed(2));
		}
	}

	checkIfDteIsGrossValue() {
		let totalByProduct = this.receivedDte.detalleDte.reduce((sum, detalle) => (sum += Math.round(detalle.cantidad * detalle.precioUnitario)), 0);
		return this.receivedDte.total == totalByProduct && this.receivedDte.exento != totalByProduct;
	}
	sendNullType() {
		this.typeOfNullfySelected.emit(this.typeOfNullify[this.dteNullifyForm.controls.radioNullType.value]);
	}

	detectChangeDate(event) {
		this.validDate = true;
		let fromDate: any;
		if (event.startDate != null) {
			this.dateEmision = event;
		} else {
			if (event.target != null && event.target.value != null) {
				this.validDate = moment(event.target.value, this.locale.format, true).isValid();
				if (this.validDate) {
					fromDate = new Object();
					fromDate.startDate = moment(event.target.value, this.locale.format);
					this.dateEmision = fromDate;
				}
			}
		}
	}
	verifyFolios() {
		const emisorId = this.tokenContainer.getCompany();
		const sucursalId = this.tokenContainer.getSubsidiary();
		let codigoSii: number;

		if (this.isExportDteForNullification(this.receivedDte.codigoTipoDte)) {
			codigoSii = this.DebitoMode ? 111 : 112;
		} else {
			codigoSii = this.DebitoMode ? 56 : 61;
		}
		this.codigoSiiValidado = codigoSii;

		this.foliosService.getDataByType(emisorId, sucursalId, codigoSii).subscribe(
			(res) => {
				const totalFolios = res.data
					?.filter((item) => item.codigoSii === codigoSii)
					.reduce((acumulador, item) => acumulador + item.foliosDisponibles, 0) || 0;
				this.totalFoliosDisp = totalFolios;
			},
			(error) => {
				Swal.fire({
					icon: "error",
					title: "Error en validación",
					text: "No fue posible realizar la validación del folios.",
				});
			}
		);
	}
	private isExportDteForNullification(codigoTipoDte: number): boolean {
		return codigoTipoDte === 110 || codigoTipoDte === 111 || codigoTipoDte === 112;
	}
	private getTipoFolioDescripcion(codigoSii: number): string {
		if (codigoSii === 111) return "emitir Notas de Débito de Exportación";
		if (codigoSii === 112) return "emitir Notas de Crédito de Exportación";
		if (codigoSii === 56) return "emitir Notas de Débito";
		if (codigoSii === 61) return "emitir Notas de Crédito";
		return "emitir los documentos requeridos";
	}
	private setupGlobalDiscountBehavior(): void {
		const applyCtrl = this.dteAmountNullForm.get("applyGlobalDiscount");
		const valueCtrl = this.dteAmountNullForm.get("globalDiscountValue");

		if (!applyCtrl || !valueCtrl) return;

		// Si no existe descuento/recargo global, deja todo deshabilitado
		if (!this.hasGlobalDiscountOrSurcharge) {
			applyCtrl.disable({ emitEvent: false });
			valueCtrl.disable({ emitEvent: false });
			return;
		}

		// Estado inicial (por si el checkbox parte marcado)
		if (applyCtrl.value === true) {
			valueCtrl.setValue(this.globalDiscountOriginalValue, { emitEvent: false });
			valueCtrl.disable({ emitEvent: false });
		} else {
			valueCtrl.enable({ emitEvent: false });
		}

		// Reaccionar a cambios
		applyCtrl.valueChanges.subscribe((checked: boolean) => {
			if (checked) {
			valueCtrl.setValue(this.globalDiscountOriginalValue, { emitEvent: false });
			valueCtrl.disable({ emitEvent: false });
			} else {
			valueCtrl.enable({ emitEvent: false });
			// opcional: valueCtrl.setValue(0, { emitEvent: false });
			}
		});
		applyCtrl?.valueChanges.subscribe(() => {
			this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.noteToSend);
		});
			valueCtrl?.valueChanges.subscribe(() => {
			this.calculateNewTotalsOfDocument(this.rowsDetalles, this.totalesNota, this.noteToSend);
		});
	}

}
